(function ($, drupalSettings, Drupal) {
	Drupal.eta = 450;

	Drupal.breakpoint = {
		small: 560,
		medium: 740,
		large: 960,
		max: 1060,
	};

	Drupal.behaviors.global = {
		attach: function (context) {
		}
	};

	var getAnimOpts = function (a, b, c) {
		if (!a) { return { duration: 'normal' }; }
		if (!!c) { return { duration: a, easing: b, complete: c }; }
		if (!!b) { return { duration: a, complete: b }; }
		if (typeof a === 'object') { return a; }
		return { duration: a };
	};
	var getUnqueuedOpts = function (opts) {
		return {
			queue: false,
			duration: opts.duration,
			easing: opts.easing
		};
	};

	$.fn.slideFadeIn = function (a, b, c) {
		var slideOpts = getAnimOpts(a, b, c), fadeOpts = getUnqueuedOpts(slideOpts);
		$(this).hide().css('opacity', 0).slideDown(slideOpts).animate({ opacity: 1 }, fadeOpts);
	};
	$.fn.slideFadeOut = function (a, b, c) {
		var slideOpts = getAnimOpts(a, b, c), fadeOpts = getUnqueuedOpts(slideOpts);
		$(this).show().css('opacity', 1).slideUp(slideOpts).animate({ opacity: 0 }, fadeOpts);
	};
})(jQuery, drupalSettings, Drupal);


(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.hoverLabelInputs = {
		attach: function (context) {
			$('.form-item', context).each(function () {
				Drupal.checkHoverLabelInputs($(this));
			});
			$('.form-item :input', context)
				.on('focus', function () {
					var $row = $(this).closest('.form-item');
					$row.removeClass('js-label-shift');
				})
				.on('blur', function () {
					var $row = $(this).closest('.form-item');
					Drupal.checkHoverLabelInputs($row);
				});
		}
	};

	Drupal.checkHoverLabelInputs = function ($cur) {
		if ($(':input', $cur).val() != '') {
			$cur.removeClass('js-label-shift');
		}
		else {
			$cur.addClass('js-label-shift');
		}
	};

	Drupal.behaviors.linkValidator = {
		attach: function (context) {
			$('[type="url"]', context).blur(function (e) {
				var l = String($(this).val());
				if (l.indexOf('http://') != 0 && l.indexOf('https://') != 0) {
					$(this).val('https://' + l);
				}
			});
		}
	};
})(jQuery, drupalSettings, Drupal);

